<div class="flex items-center">
  <div [class]="computedClass()"></div>
  <div class="ml-4 font-bold text-primary" [class]="textClasses()"><ng-content></ng-content></div>
</div>
